module.exports = __webpack_public_path__ + "img/image-ua.4b98cb30.png";